import { useQuery } from '@tanstack/react-query';

import {
  getResourcesGroups,
  getRoadmapDefaultResourceAllocations,
  getRoadmapResourcesByUser,
  getRoadmapResourceYearByResource,
  getRoadmapResourceYearByYear,
} from '../api';

export const useResourceGroups = (year?: number, includeDeleted?: boolean, enabled = true) =>
  useQuery({
    queryKey: ['resource', 'resource-groups', year, includeDeleted],
    queryFn: async () => await getResourcesGroups({ year, includeDeleted }),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useRoadmapDefaultResourceAllocations = (enabled = true) =>
  useQuery({
    queryKey: ['resource', 'roadmap-default-allocations'],
    queryFn: async () => await getRoadmapDefaultResourceAllocations(),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useRoadmapResourceYearByYear = (year: number, enabled = true) =>
  useQuery({
    queryKey: ['resource', 'roadmap-resource-year-by-year', year],
    queryFn: async () => await getRoadmapResourceYearByYear(year),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useRoadmapResourceYearByResource = (resourceId: number, enabled = true) =>
  useQuery({
    queryKey: ['resource', 'roadmap-resource-year-by-resource', resourceId],
    queryFn: async () => await getRoadmapResourceYearByResource(resourceId),
    staleTime: 1000 * 60 * 15,
    enabled,
  });

export const useRoadmapResourceByUser = () =>
  useQuery({
    queryKey: ['resource-by-user'],
    queryFn: getRoadmapResourcesByUser,
    staleTime: 1000 * 60 * 15,
  });
